import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from "@angular/core";
import { User } from "src/app/_models/User";
import { PermissionService } from "src/app/_services/permission.service";

@Directive({
  selector: "[permissionLock]",
})
export class PermissionLock implements OnInit, OnChanges {
  currentUser: User;
  private permissions = [];
  private logicalOp = "AND";
  private isHidden = true;
  contentText: string;

  @Input()
  set requiredPermissions(val: any[]) {
    this.permissions = val;
  }

  @Input()
  set permissionOp(permop: string) {
    this.logicalOp = permop;
  }

  constructor(
    private elementRef: ElementRef,
    private permissionService: PermissionService,
    private renderer: Renderer2
  ) {
    if (this.elementRef.nativeElement.innerText !== "undefined") {
      this.contentText = this.elementRef.nativeElement.outerHTML;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.updateView();
  }
  ngOnInit(): void {
    this.updateView();
  }

  private setLock() {
    const body = `<div>
    <input type="checkbox" disabled />
    <span></span>
    ${this.contentText}
    </div>
    `;
    this.renderer.setProperty(this.elementRef.nativeElement, "outerHTML", body);
  }

  private clearLock() {
    if (this.contentText) {
      this.renderer.setProperty(
        this.elementRef.nativeElement,
        "outerHTML",
        this.contentText
      );
    }
  }

  private updateView() {
    this.permissionService
      .checkPermission(this.permissions, this.logicalOp)
      .subscribe((permission) => {
        if (permission) {
          if (this.isHidden) {
            this.setLock();
            this.isHidden = false;
          }
        } else {
          this.isHidden = true;
          this.clearLock();
        }
      });
  }
}
